export default __webpack_public_path__ + "static/media/analytics.5dbe707a.png";